import ServicesCard from "../Services/ServicesCard";
import {useServiceCard} from "../../store/services";

const OurServices = () => {
    const services = useServiceCard((store) => store.services)
    return (
        <div className="nom">
            <div className="services__grid mb-32 p-25r">
                {services.map((item, i) => <ServicesCard key={i} props={item} count={i}/>)}
            </div>
        </div>
    )
}
export default OurServices